import React, {Component} from 'react';
//import TestData from './data'
import ErrorMessage from '../ErrorMessage'
import DataFilter from '../DataFilter'
import Moment from 'moment';
import PrintButton from '../PrintButton'
import ElaboraButton from '../ElaboraButton'
import LocalDate from '../LocalDate'
import LoadingInline from '../LoadingInline'
import CommesseSelect from '../commesse/CommessaSelect'
import ReportCommessePrevisionale from './ReportCommessePrevisionale'
import ReportCommesseGaraLavoratori from './ReportCommesseGaraLavoratori'
import ReportCommesseLavoratori from './ReportCommesseLavoratori'
import ReportCommesseLavoratoriPerAnno from './ReportCommesseLavoratoriPerAnno'
import ReportCommesseCostidiretti from './ReportCommesseCostidiretti'
// import ReportCommesseCostiindiretti from './ReportCommesseCostiindiretti'
import ReportCommesseFattureProforme from './ReportCommesseFattureProforme'
// import ReportCommesseDocumenti from './ReportCommesseDocumenti'
import PropTypes from 'prop-types';
import {createInstance} from '../../Helpers';
import { Checkbox } from 'semantic-ui-react'
import {client} from '../../Client';

class ReportCommesse extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modo: 0, // 0: attesa, 1:caricamento
            viewCharts: false,
            filterInfo: {
                tipo: 'p',
                dataStart: Moment().subtract(7, 'days').format("YYYY-MM-DD"),
                dataEnd: Moment().format("YYYY-MM-DD"),
            },
            _loading: false,
            _loading_1: false,
            _loading_2: false,
            _loading_3: false,
            _loading_4: false,
            _loading_5: false,
            _loading_6: false,
            _loading_7: false,
            error: null,
            column: null,
            direction: null,
            commessa: undefined,
            commesseAttive: [],

        };
        this.storeInstance = createInstance();
        this.onChangeCommessa = this.onChangeCommessa.bind(this)
        this.onChangeData = this.onChangeData.bind(this)
        this.onViewChartsChange = this.onViewChartsChange.bind(this)
        this.loadData = this.loadData.bind(this)
        this.loadCommesseAttive = this.loadCommesseAttive.bind(this)
        this.loadCommessaMaxMinDate = this.loadCommessaMaxMinDate.bind(this)
        this.isDataAvailable = this.isDataAvailable.bind(this)
        this.renderContent = this.renderContent.bind(this)
    }

    componentWillUnmount() {
        if (this.storeInstance) {
            this.storeInstance.save('reportCommesse', {commessa: this.state.commessa, commesseAttive: this.state.commesseAttive});
        }
    }

    componentDidMount() {
        if (this.storeInstance && this.storeInstance.restore('reportCommesse', this , () => {
                this.onChangeCommessa(this.state.commessa)
            }) === null){

            this.loadCommesseAttive();
        } else {
            this.loadCommesseAttive();
        }
    }

    onViewChartsChange(a1, {name, checked}){
        this.setState({viewCharts: checked})
    }

    onChangeCommessa(commessa){

        if ( commessa !== undefined) {
            this.loadCommessaMaxMinDate(commessa);
        }
        else{
            this.setState({commessa: commessa});
        }


        // let filter = this.state.filterInfo;
        // if ( commessa !== undefined){
        //
        //     // Vecchia versione- ora utilizza datamax e min proveniente dal server
        //     if (commessa.dataIncarico){
        //         filter.dataStart = Moment(commessa.dataIncarico).format("YYYY-MM-DD");
        //         filter.tipo = 'p';
        //     }else if (commessa.dataInizioPrestazione){
        //         filter.dataStart = Moment(commessa.dataInizioPrestazione).format("YYYY-MM-DD");
        //         filter.tipo = 'p';
        //     } else {
        //         filter.dataStart = Moment().subtract(1, 'month').format("YYYY-MM-DD");
        //         filter.tipo = 'p';
        //     }
        //
        //     if (commessa.dataChiusura){
        //         filter.dataEnd = Moment(commessa.dataChiusura).format("YYYY-MM-DD");
        //         filter.tipo = 'p';
        //     }else if (commessa.dataFinePrestazione){
        //         filter.dataEnd = Moment(commessa.dataFinePrestazione).format("YYYY-MM-DD");
        //         filter.tipo = 'p';
        //     }else {
        //         filter.dataEnd = Moment().format("YYYY-MM-DD");
        //         filter.tipo = 'p';
        //     }
        // }
        // this.setState({commessa: commessa, filterInfo: filter, modo: 0})
    }

    onChangeData(tipo, dataDal, dataAl){
        let filter = this.state.filterInfo;
        filter.dataStart = dataDal !== '' ? dataDal : undefined;
        filter.dataEnd = dataAl !== '' ? dataAl : undefined;
        filter.tipo = tipo;
        this.setState({filterInfo: filter, modo: 0})
    }

    loadCommesseAttive(){

        // Non più udsata. Disabilitata
        return;

        // this.setState({ _loading: true });
        // client.loadCommesseTutteList().then((response) => {
        //     if (response.ok)
        //     {
        //         response.json().then((data)=>{
        //             this.setState({
        //                 _loading: false,
        //                 error: null,
        //                 commesseAttive: data.items
        //             })
        //         })
        //     }
        //     else if (response.status === 401)
        //     {
        //         this.props.history.push("/login")
        //     }            else
        //     {
        //         response.json().then((errore) => {
        //             let fieldErrorsText = []
        //             let fieldErrors = {}
        //             this.setState({
        //                 _loading: false,
        //                 fieldErrors: fieldErrors,
        //                 fieldErrorsText: fieldErrorsText,
        //                 errorTitle: '',
        //                 error: {title: errore.title, msg: errore.msg},
        //                 inError: true
        //             });
        //         });
        //     }
        // }).catch((error) => {
        //     let fieldErrorsText = []
        //     let fieldErrors = {}
        //     this.setState({
        //         _loading: false,
        //         fieldErrors: fieldErrors,
        //         fieldErrorsText: fieldErrorsText,
        //         errorTitle: '',
        //         error: {title: "Errore di rete imprevisto", msg: error.message},
        //         inError: true
        //     });
        // });
    }

    loadCommessaMaxMinDate(commessa){

        this.setState({ _loading: true });
        client.loadCommessaMaxMinDate(commessa.idCommessa).then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    let filter = this.state.filterInfo;
                    filter.dataStart = data.startDate;
                    filter.dataEnd = data.endDate;
                    filter.tipo = 'p';
                    this.setState({
                        _loading: false,
                        error: null,
                        commessa: commessa,
                        filterInfo:
                        filter, modo: 0
                    })
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }            else
            {
                response.json().then((errore) => {
                    let fieldErrorsText = []
                    let fieldErrors = {}
                    this.setState({
                        _loading: false,
                        fieldErrors: fieldErrors,
                        fieldErrorsText: fieldErrorsText,
                        errorTitle: '',
                        error: {title: errore.title, msg: errore.msg},
                        inError: true
                    });
                });
            }
        }).catch((error) => {
            let fieldErrorsText = []
            let fieldErrors = {}
            this.setState({
                _loading: false,
                fieldErrors: fieldErrors,
                fieldErrorsText: fieldErrorsText,
                errorTitle: '',
                error: {title: "Errore di rete imprevisto", msg: error.message},
                inError: true
            });
        });
    }

    loadData() {
        this.setState({modo: this.state.modo === 0 ? 1 : 0 });
    }

    render() {
        let i = 1;
        if (this.state.error !== null)
        {
            return (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg} />)
        }
        let loader = '';
        if  (this.state._loading) {
            loader = (
                <div className="ui active inverted dimmer">
                <div className="ui loader"></div>
                </div>
            );
        }


        let stampaButton = null;
        if (this.isDataAvailable()){
            stampaButton = <PrintButton/>
        }

        return (<div className="ui">
            <h3 className="ui top block attached header no-print">
                <i className="shopping bag icon"/> Resoconto Completo Commessa
            </h3>
            <div className="ui attached segment no-print">
            <div className="ui two column stackable grid ">
                <div className="column">
                    <CommesseSelect
                        onChange={this.onChangeCommessa}
                        fluid="true"
                        compact={true}
                        commessa={this.state.commessa}
                        //commesseList={this.state.commesseAttive}
                    />
                </div>
                <div className="column">
                    <div className="ui one column grid ">
                        <div className="column">
                            <Checkbox label="Mostra Grafici" name="isChiusa" toggle checked={this.state.viewCharts} onChange={this.onViewChartsChange} />
                        </div>
                        <div className="column">
                            <DataFilter
                                tipo={this.state.filterInfo.tipo}
                                dataDal={this.state.filterInfo.dataStart}
                                dataAl={this.state.filterInfo.dataEnd}
                                fireOnChangeOnStart={true}
                                onChange={this.onChangeData}
                            />

                            <ElaboraButton text="Elabora" onClick={this.loadData} /> {stampaButton}
                        </div>
                    </div>


                </div>
            </div>
            </div>

            {this.isDataAvailable() ? this.renderContent() : null}
            {loader}
        </div>)
    }

    isDataAvailable(){
        return this.state.commessa !== undefined && this.state.modo === 1;
    }

    renderContent(){
        let commessa = this.state.commessa;
        return (
            <div className="ui segments">

                <div className="ui attached top segment">
                    <h2 className="ui  header">Resoconto Completo Commessa
                    <div className="sub header">Periodo dal <b><LocalDate data={this.state.filterInfo.dataStart}/></b> al <b><LocalDate data={this.state.filterInfo.dataEnd}/></b></div>
                    </h2>
                </div>
                <h3 className="ui attached header">Dati Commessa</h3>
                <div className="ui attached segment">
                <div className="ui four columns grid">
                    <div className="row">
                        <div className="sixteen wide column">
                            <h4><label className="ui empty circular big label" style={{backgroundColor: commessa.colore}}></label>{commessa.nomeCompleto}</h4>
                        </div>
                        <div className="sixteen wide column"> {commessa.oggetto}</div>
                        <div className="four wide column"> <b>{commessa.ragioneSociale}</b></div>
                        <div className="twelve wide column">  {commessa.indirizzo} {commessa.cap} {commessa.citta} {commessa.provincia} {commessa.piva} {commessa.cfisc}</div>
                    </div>
                    <div className="row">
                        <div className="column">Data Incarico:</div><div className="column"><b><LocalDate data={commessa.dataIncarico}/></b></div>
                        <div className="column">Data chiusura:</div><div className="column"><b><LocalDate data={commessa.dataChiusura}/></b></div>
                        <div className="column">Data inizio prestazioni:</div><div className="column"><b><LocalDate data={commessa.dataInizioPrestazione}/></b></div>
                        <div className="column">Data fine prestazioni:</div><div className="column"><b><LocalDate data={commessa.dataFinePrestazione}/></b></div>
                    </div>
                </div>
                </div>

                <h3 className="ui attached header">Attività sull'eventuale Gara associata<LoadingInline visible={this.state._loading_1}/></h3>
                <div className="ui attached segment">
                    <ReportCommesseGaraLavoratori commessa={commessa} viewCharts={this.state.viewCharts} />
                </div>

                <h3 className="ui attached header">Percentuale Ore lavorate/Previsionale <LoadingInline visible={this.state._loading_7}/></h3>
                <div className="ui attached segment">
                    <ReportCommessePrevisionale commessa={commessa} dataStart={this.state.filterInfo.dataStart} dataEnd={this.state.filterInfo.dataEnd} viewCharts={this.state.viewCharts} />
                </div>
                <h3 className="ui attached header">Lavoratori <LoadingInline visible={this.state._loading_1}/></h3>
                <div className="ui attached segment">
                    <ReportCommesseLavoratori commessa={commessa} dataStart={this.state.filterInfo.dataStart} dataEnd={this.state.filterInfo.dataEnd} viewCharts={this.state.viewCharts} />
                </div>
                <ReportCommesseLavoratoriPerAnno commessa={commessa} dataStart={this.state.filterInfo.dataStart} dataEnd={this.state.filterInfo.dataEnd} viewCharts={this.state.viewCharts} />
                <h3 className="ui attached header"> <LoadingInline visible={this.state._loading_2}/></h3>
                <div className="ui attached segment">
                    <ReportCommesseCostidiretti commessa={commessa} dataStart={this.state.filterInfo.dataStart} dataEnd={this.state.filterInfo.dataEnd}  viewCharts={this.state.viewCharts} />
                </div>
                <h3 className="ui attached header">Fatture emesse <LoadingInline visible={this.state._loading_4}/></h3>
                <div className="ui attached segment">
                    <ReportCommesseFattureProforme tipo="F" commessa={commessa} dataStart={this.state.filterInfo.dataStart} dataEnd={this.state.filterInfo.dataEnd}  viewCharts={this.state.viewCharts} />
                </div>
                <h3 className="ui attached header">Proforme emesse <LoadingInline visible={this.state._loading_5}/></h3>
                <div className="ui attached segment">
                    <ReportCommesseFattureProforme tipo="P" commessa={commessa} dataStart={this.state.filterInfo.dataStart} dataEnd={this.state.filterInfo.dataEnd}  viewCharts={this.state.viewCharts} />
                </div>
{/*
                <h3 className="ui attached header">Documenti prodotti <LoadingInline visible={this.state._loading_6}/></h3>
                <div className="ui attached segment">
                    <ReportCommesseDocumenti  commessa={commessa} dataStart={this.state.filterInfo.dataStart} dataEnd={this.state.filterInfo.dataEnd}  viewCharts={this.state.viewCharts} />
                </div>
*/}

{/* 
    Tolto con richiesta del 16/07/2026
                <h3 className="ui attached header">Costi indiretti <LoadingInline visible={this.state._loading_3}/></h3>
                <div className="ui attached segment">
                    <ReportCommesseCostiindiretti commessa={commessa} dataStart={this.state.filterInfo.dataStart} dataEnd={this.state.filterInfo.dataEnd}  viewCharts={this.state.viewCharts} />
                </div>
 */}
            </div>
        )
    }
}

ReportCommesse.contextTypes = {
    router: PropTypes.object
}

export default ReportCommesse;




/** WEBPACK FOOTER **
 ** ./src/components/report/ReportCommesse.js
 **/